const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 400,
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M180.01 689.47c-6.608-.485-30.383 25.265-36.606 34.322-5.695 6.905 4.795 11.13 8.863 16.984 5.133 8.061 1.221 89.907-8.338 135.137l15.468-2.31c10.152-37.07 17.661-105.92 25.262-112.08 7.234-5.649 23.672-5.054 21.675-13.416-4.133-18.673-20.446-58.426-26.324-58.637",
    style: {
      fill: "#19328c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(.974 0 0 1.00441 -5.25 -669.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.017 796.927c-18.916.88-28.798 10.698-1.05 14.5 32.7 1.345 100.915-5.958 100.992-15.21.5-12.386-9.68-30.361-15.727-30.25-4.81.067-14.607 6.082-15.498 13.352-.772 8.525-50.992 16.59-68.717 17.608M153.672 848.845c25.632-10.563 45.928-20.434 70.167-33.785 8.504-4.398 16.46 4.652 14.716 10.495-1.134 3.798-14.086 26.768-2.696 27.664-10.298 8.03-38.07 31.797-54.005 67.804l-24.83-2.098c10.656-26.667 51.37-71.181 48.61-74.101-4.7-5.087-42.154 13.54-50.337 11.19z",
    style: {
      fill: "#19328c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(.974 0 0 1.00441 -5.25 -669.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.29 893.366c40.084-21.63 128.924-41.186 200.564-42.297 9.116-.557 30.914 52.374 30.721 61.518-.599 26.028-45.433 88.498-73.247 126.117-5.793 6.423-18.898 4.847-27.696-.618l-47.537-31.564c-4.805-4.05-3.005-12.591 5.05-7.744 10.64 6.55 32.405 14.859 44.465 16.434 11.075 1.473 48.137-86.153 50.355-100.93 1.302-6.708-7.483-39.243-23.333-40.272-107.244 3.993-143.147 35.796-157.54 37.248z",
    style: {
      fill: "#19328c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(.974 0 0 1.00441 -5.25 -669.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.177 856.075c-8.33 2.473-5.544 12.923-4.36 19.234 9.768 43.249 46.334 125.35 53.642 130.24 22.498 12.483 31.295 4.164 30.913-5.245-1.136-9.12-30.28-84.444-48.576-124.2-6.317-12.702-22.054-22.438-31.62-20.03M69.202 835.833c-13.711-6.448-9.284-18.128 9.262-11.096 42.106 15.716 58.237 41.971 71.995 93.683l-15.467 4.196c-13.278-48.921-29.091-67.069-65.79-86.783",
    style: {
      fill: "#19328c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(.974 0 0 1.00441 -5.25 -669.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.217 943.33c-15.905 5.904-13.031-18.01-2.259-21.031 74.131-23.15 77.605-21.158 89.999-16.23 11.852 4.762 16.094 21.95.35 21.098-31.186-1.969-55.587 2.55-88.09 16.163M124.257 959.255c-10.222 2.707-7.017 18.269 3.278 15.95 26.744-5.663 45.57-9.032 73.05-12.997 8.282-1.374 8.023-22.578.54-25.883-10.09-3.027-11.22 3.618-15.653 6.113-12.14 6.207-37.22 10.448-61.215 16.817",
    style: {
      fill: "#19328c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(.974 0 0 1.00441 -5.25 -669.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.802 925.408c2.232 25.8 4.914 54.748 1.748 80.549l17.523 9.644c3.127-29.675 6.514-63.196 4.251-92.87z",
    style: {
      fill: "#19328c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(.974 0 0 1.00441 -5.25 -669.803)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNan);
export default __webpack_public_path__ + "static/media/Nan.8c186e24b5b9f7b642c6f1d0b7ea388d.svg";
export { ForwardRef as ReactComponent };